var _path, _path2, _path3, _path4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.6667 24.0001C18.6667 25.4728 19.8606 26.6667 21.3333 26.6667C22.8061 26.6667 24 25.4728 24 24.0001C24 22.5273 22.8061 21.3334 21.3333 21.3334C19.8606 21.3334 18.6667 22.5273 18.6667 24.0001Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.3333 10.0001C22.8061 10.0001 24 8.80617 24 7.33341C24 5.86066 22.8061 4.66675 21.3333 4.66675C19.8606 4.66675 18.6667 5.86066 18.6667 7.33341C18.6667 8.80617 19.8606 10.0001 21.3333 10.0001Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M6 16.0001C6 17.4728 7.19391 18.6667 8.66667 18.6667C10.1394 18.6667 11.3333 17.4728 11.3333 16.0001C11.3333 14.5273 10.1394 13.3334 8.66667 13.3334C7.19391 13.3334 6 14.5273 6 16.0001Z",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.666 14.0001L19.3327 8.66675M10.666 18.0001L19.3327 23.3334",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_8416_2666",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15 15.6667) rotate(61.2646) scale(18.7201 30.4474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1772,
    stopColor: "#151F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607973,
    stopColor: "#113782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85436,
    stopColor: "#919BEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_8416_2666",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15 15.6667) rotate(61.2646) scale(18.7201 30.4474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1772,
    stopColor: "#151F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607973,
    stopColor: "#113782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85436,
    stopColor: "#919BEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_8416_2666",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15 15.6667) rotate(61.2646) scale(18.7201 30.4474)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1772,
    stopColor: "#151F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607973,
    stopColor: "#113782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85436,
    stopColor: "#919BEC"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_8416_2666",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.9993 16.0001) rotate(68.3971) scale(11.7699 15.5444)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1772,
    stopColor: "#151F40"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.607973,
    stopColor: "#113782"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85436,
    stopColor: "#919BEC"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareIcon);
export default __webpack_public_path__ + "static/media/share_icon.45b75f3f41a88916f7a3b9c6e7d6bdc0.svg";
export { ForwardRef as ReactComponent };